import { render, staticRenderFns } from "./category-bisac-create.vue?vue&type=template&id=486f363a&"
import script from "./category-bisac-create.vue?vue&type=script&lang=js&"
export * from "./category-bisac-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports